import React, { useEffect, useState } from 'react';
import { Box, Button, Link, Stack, Typography } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import LoggingService from '../shared/Logging.api';
import SpinningSpark from '../shared/components/SpinningSpark';
import TasksService from './Tasks.api';

export default function TasksPage() {
  const navigate = useNavigate();
  const [tasks, setTasks] = useState(null);

  useEffect(() => {
    TasksService.getTasks()
      .then(setTasks)
      .catch((error) => {
        LoggingService.error('Failed to load tasks', error);
        setTasks([]);
      });
  }, []);

  if (!tasks) {
    return (
      <Box display="flex" justifyContent="center" minHeight={240} pt={6}>
        <SpinningSpark height="50" />
      </Box>
    );
  }

  return (
    <Stack spacing={2}>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography component="h1" variant="h5">
          Content requests
        </Typography>
        <Button variant="contained" onClick={() => navigate('/tasks/new')}>
          New task
        </Button>
      </Stack>

      {tasks.length === 0 ? (
        <Typography color="text.secondary">No tasks yet.</Typography>
      ) : (
        <Stack
          component="ul"
          spacing={1}
          sx={{ listStyle: 'none', m: 0, p: 0 }}
        >
          {tasks.map((task, index) => (
            <Box component="li" key={task.task_id}>
              <Link
                component={RouterLink}
                to={`/tasks/${task.task_id}`}
                underline="hover"
              >
                {index + 1}. {task.title || `Untitled task ${task.task_id}`}
              </Link>
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  );
}
